import { render, staticRenderFns } from "./scor_radio_v.vue?vue&type=template&id=401ac873&scoped=true&"
import script from "./scor_radio_v.vue?vue&type=script&lang=js&"
export * from "./scor_radio_v.vue?vue&type=script&lang=js&"
import style0 from "./scor_radio_v.vue?vue&type=style&index=0&id=401ac873&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ac873",
  null
  
)

export default component.exports